/**
 * The id to put in an API URL for a record, or null when the record only exists
 * locally (a `local_…` temp id minted before its POST completed). Ids are uuids
 * on the live API, so they must never be coerced with Number().
 */
export function apiId(id: string | number | null | undefined): string | null {
  if (id === null || id === undefined) return null;
  const s = String(id).trim();
  if (s === '' || s.startsWith('local_')) return null;
  return s;
}
